import { Component, OnInit } from '@angular/core';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, Observer } from 'rxjs';
import { FormBuilderBasicInputComponentModel } from '../../models/form-builder-basic-input-component-model';

@Component({
  selector: 'tf-core-fb-basic-input-single-select',
  templateUrl: './fb-basic-input-single-select.component.html',
  styleUrls: ['./fb-basic-input-single-select.component.css']
})
export class FbCoreBasicInputSingleSelectComponent extends FormBuilderBasicInputComponentModel implements OnInit {
    public data = {
        component: null,
        editorData: '',
        editorActive: false,
        hasChanges: false,
        viewType: 'default',
        toggleTooltips: false,
        formGroup: null,
        controlName: ''
    };

    public optionImageUrl = 'https://httpbin.org/post';

    public beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
        return new Observable((observer: Observer<boolean>) => {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

            if (!isJpgOrPng) {
                this.msg.error('You can only upload JPG file!');

                observer.complete();

                return;
            }

            const isLt2M = file.size! / 1024 / 1024 < 2;
          
            if (!isLt2M) {
                this.msg.error('Image must smaller than 2MB!');

                observer.complete();

                return;
            }

            observer.next(isJpgOrPng && isLt2M);

            observer.complete();
        });
    };

    constructor(
        private msg: NzMessageService,
    ) {
        super();
    }

    ngOnInit(): void {
        super.init();
    }

    get layout(): string {
        return this.data.component.layout;
    }

    get options(): any[] {
        if (this.layout === 'horizontal') {
            return this.data.component.options.slice(0, 3);
        }

        return this.data.component.options;
    }

    handleUploadChange(info: { file: NzUploadFile }, option: any): void {
        switch (info.file.status) {
            case 'uploading':
                option.loading = true;
                break;
            case 'done':
                // Get this url from response in real world.
                this.getBase64(info.file!.originFileObj!, (img: string) => {
                    option.loading = undefined;
                    option.image = img;
                });
                break;
            case 'error':
                this.msg.error('Network error');
                option.loading = undefined;
                break;
        }
    }

    private getBase64(img: File, callback: (img: string) => void): void {
        const reader = new FileReader();

        reader.addEventListener('load', () => callback(reader.result!.toString()));

        reader.readAsDataURL(img);
    }

}
